// src/components/ProductCard.js
import React, { useState } from 'react';

const ds = { fontFamily: "'Cormorant Garamond', Georgia, serif" };
const bs = { fontFamily: "'Montserrat', sans-serif" };

const ProductCard = ({ product, onProductClick }) => {
  const [hov, setHov] = useState(false);

  const handleClick = () => {
    if (typeof onProductClick === 'function') onProductClick(product);
  };

  const price = parseFloat(product.price) || 0;

  return (
    <div
      onClick={handleClick}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        cursor: 'pointer', display: 'flex', flexDirection: 'column',
        background: 'white', overflow: 'hidden',
        boxShadow: hov ? '0 16px 48px rgba(0,0,0,0.11)' : '0 2px 10px rgba(0,0,0,0.05)',
        transform: hov ? 'translateY(-4px)' : 'translateY(0)',
        transition: 'box-shadow 0.35s, transform 0.3s',
        borderRadius: '1px',
      }}
    >
      {/* Imagen */}
      <div style={{ position: 'relative', paddingBottom: '122%', overflow: 'hidden',
        background: '#f5f2f2' }}>
        {product.images?.length > 0 ? (
          <img src={product.images[0]} alt={product.name} style={{
            position: 'absolute', inset: 0, width: '100%', height: '100%',
            objectFit: 'cover',
            transform: hov ? 'scale(1.07)' : 'scale(1)',
            transition: 'transform 0.6s ease',
          }} />
        ) : (
          <div style={{ position: 'absolute', inset: 0, display: 'flex',
            flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            color: '#ccc' }}>
            <svg width="40" height="40" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14
                   m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
            </svg>
            <p style={{ ...bs, fontSize: '9px', letterSpacing: '0.2em',
              textTransform: 'uppercase', marginTop: '8px' }}>Sin imagen</p>
          </div>
        )}

        {/* Overlay con CTA */}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(to top, rgba(6,13,20,0.55) 0%, transparent 55%)',
          display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
          paddingBottom: '20px',
          opacity: hov ? 1 : 0, transition: 'opacity 0.3s',
        }}>
          <span style={{
            ...bs, background: 'white', color: '#961914',
            padding: '8px 22px', fontSize: '10px', fontWeight: 600,
            letterSpacing: '0.18em', textTransform: 'uppercase',
          }}>
            Ver Detalles
          </span>
        </div>
      </div>

      {/* Info */}
      <div style={{ padding: '16px 16px 18px', borderTop: '1px solid #f5f0f0' }}>
        {product.categoryName && (
          <p style={{ ...bs, color: '#961914', fontSize: '9.5px',
            letterSpacing: '0.22em', textTransform: 'uppercase', marginBottom: '5px' }}>
            {product.categoryName}
          </p>
        )}
        <h3 style={{ ...ds, fontSize: '1.1rem', fontWeight: 600, color: '#060D14',
          marginBottom: '5px', lineHeight: 1.3,
          display: '-webkit-box', WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
          {product.name}
        </h3>
        <p style={{ ...bs, fontSize: '12px', color: '#aaa', lineHeight: 1.6,
          marginBottom: '10px',
          display: '-webkit-box', WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
          {product.description}
        </p>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ ...ds, color: '#961914', fontSize: '1.35rem', fontWeight: 400 }}>
            ${price.toFixed(2)}
          </span>
          <span style={{ ...bs, color: '#ccc', fontSize: '9px', letterSpacing: '0.15em',
            textTransform: 'uppercase' }}>MXN</span>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
